module.exports = __webpack_public_path__ + "static/media/2.8388a37d.png";